/**
 * Default Response object
 */
export class ResponseModel<T = any> {
  header: ResponseHeader;
  payload: T;
}

/**
 * Default response header
 */
export class ResponseHeader {
  executionId: string;
  startTime: Date;
  endTime: Date;
  duration: number;
  status: number;
  messages: string[];
}

/**
 * Individual results for search endpoints
 */
export class SearchResult<T> {
  total: number;
  skip: number;
  count: number;
  result?: T[];

  /**
   * @param result - search result generic object to assign
   * @param Type - type `T` to assign on result mapping
   */
  constructor(result: SearchResult<T>, Type?: any) {
    this.total = result.total;
    this.skip = result.skip;
    this.count = result.count;
    if (result.result && Type) {
      this.result = result.result.map((r) => new Type(r));
    }
  }
}
